export default __webpack_public_path__ + "img/7495a25be9680006a35384318e583100.svg";